import { z } from "zod";
import { faArrowRotateLeft } from "@fortawesome/pro-regular-svg-icons";
import Form from "core/components/Form/Form";
import Error from "core/components/Error";
import { minLength, required, email, validate } from "common/validation";

import useForm from "core/hooks/useForm";
import Field from "core/components/Field";

const formSchema = z.object({
  name: z.string().min(2),
  email: z.email(),
  alternateEmail: z.string().optional(),
});

const UserForm = ({
  onSubmit,
  defaultValues,
  isFetching = false,
  isSubmitting,
  error,
}) => {
  const {
    formValues,
    errors,
    isDisabled,
    isTouched,
    onFormSubmit,
    onFieldChange,
    onFormReset,
    isDirty,
  } = useForm({
    placeholderValues: defaultValues,
    initialValues: defaultValues,
    disabledUntilTouched: true,
    onSubmit,
    formSchema,
    isFetchingInitialValues: isFetching,
  });

  return (
    <Form
      onSubmit={onFormSubmit}
      //   defaultValues={initialValues}
      submitLabel={"Save Changes"}
      onCancel={defaultValues?.email && isDirty && onFormReset}
      isFetching={isFetching}
      isSubmitting={isSubmitting}
      disabled={isDisabled}
      isTouched={isTouched}
      mode={defaultValues?.name ? "update" : "create"}
      cancelLabel={"Reset"}
      cancelIcon={faArrowRotateLeft}
    >
      <Error>{error}</Error>

      <Field
        type="text"
        id="name"
        labelText="Name"
        showSkeleton={isFetching}
        autoComplete="off"
        isRequired={true}
        value={formValues.name}
        error={errors.name}
        onChange={(value, errorMessage) => {
          onFieldChange("name")(value, errorMessage);
          onFieldChange("email")(formValues.email);
        }}
        validator={validate(required(), minLength(2))}
      />
      <Field
        type="text"
        id="email"
        labelText="Email"
        showSkeleton={isFetching}
        autoComplete="off"
        isRequired={true}
        value={formValues.email}
        error={errors.email}
        onChange={onFieldChange("email")}
        validator={validate(required(), email())}
        isDisabled={true}
      />
      <Field
        type="text"
        id="alternateEmail"
        labelText="Alternate Email"
        showSkeleton={isFetching}
        autoComplete="off"
        value={formValues.alternateEmail}
        error={errors.alternateEmail}
        onChange={(value, errorMessage) => {
          onFieldChange("alternateEmail")(value, errorMessage);
          onFieldChange("email")(formValues.email);
        }}
        validator={validate(email())}
      />
    </Form>
  );
};

export default UserForm;
